// Above this brightness the marker colour takes dark text, below it white.
export const NOTE_LIGHT_FRAME_LUMINANCE = 0.6;
export const NOTE_DARK_INK = "#2A1F00";
export const NOTE_LIGHT_INK = "#FFFFFF";
export const NOTE_GLOW_ALPHA = 0.32;

// The "Show more" pill: a light wash of the marker colour, labelled in a dark shade of it so it reads on white.
export const NOTE_PILL_ALPHA = 0.16;
export const NOTE_DEEP_SHADE = 0.45;

// The clamped text fades out over its last lines instead of ending on a hard cut.
export const NOTE_FADE_MASK =
  "linear-gradient(to bottom, #000 60%, transparent 100%)";
